import React from 'react'
import { Link } from 'react-router-dom'
import MarketingSiteLayout from '../../marketing/MarketingSiteLayout'
import { PUBLIC_INQUIRY_PATH } from '../../marketing/marketingNav'

export default function SupportQnaPage() {
  return (
    <MarketingSiteLayout>
      <div className="mx-auto max-w-3xl px-4 py-14 md:py-20">
        <nav className="text-sm text-slate-500">
          <Link to="/support" className="hover:text-brand-navy">
            고객센터
          </Link>
          <span className="mx-2">/</span>
          <span className="text-slate-800">Q&A</span>
        </nav>
        <h1 className="mt-6 text-3xl font-black text-slate-900 sm:text-4xl">Q&A · 문의 안내</h1>
        <div className="mt-8 space-y-8 text-sm leading-7 text-slate-700">
          <section>
            <h2 className="text-lg font-bold text-slate-900">1. 공개 문의 (비로그인)</h2>
            <p className="mt-2">
              도입·제휴·가입 전 궁금하신 점은{' '}
              <Link to={PUBLIC_INQUIRY_PATH} className="font-semibold text-brand-navy hover:underline">
                문의하기 페이지
              </Link>
              에서 남겨 주세요. 운영 쪽으로 전달됩니다.
            </p>
          </section>
          <section>
            <h2 className="text-lg font-bold text-slate-900">2. 고객문의 (로그인)</h2>
            <p className="mt-2">
              서비스 이용 중 문의·버그·개선 요청은 로그인 후{' '}
              <Link to="/support/inquiries" className="font-semibold text-brand-navy hover:underline">
                고객문의
              </Link>
              메뉴에서 비공개로 접수할 수 있어요. 답변도 같은 화면에서 확인합니다.
            </p>
          </section>
          <section>
            <h2 className="text-lg font-bold text-slate-900">3. 게시판형 Q&A</h2>
            <p className="mt-2">누구나 읽을 수 있는 질문 게시판 형태는 추후 도입을 검토 중이에요. 지금은 FAQ와 위 채널을 이용해 주세요.</p>
          </section>
        </div>
        <div className="mt-12 flex flex-wrap gap-3">
          <Link to="/support/faq" className="rounded-full border border-slate-200 bg-white px-5 py-2.5 text-sm font-semibold hover:border-sky-200">
            FAQ 보기
          </Link>
          <Link to="/support" className="rounded-full bg-brand-navy px-5 py-2.5 text-sm font-bold text-white hover:bg-sky-700">
            고객센터 홈
          </Link>
        </div>
      </div>
    </MarketingSiteLayout>
  )
}
